import { useEffect, useRef } from 'react'

import { loadTurnstileScript } from '../utils/turnstile'

export default function Turnstile ({ siteKey, onToken, resetSignal = 0 }) {
  const containerRef = useRef(null)
  const widgetIdRef = useRef(null)
  const onTokenRef = useRef(onToken)

  useEffect(() => {
    onTokenRef.current = onToken
  }, [onToken])

  useEffect(() => {
    let cancelled = false

    if (!siteKey) {
      return undefined
    }

    loadTurnstileScript()
      .then(turnstile => {
        if (cancelled || !containerRef.current) {
          return
        }

        widgetIdRef.current = turnstile.render(containerRef.current, {
          sitekey: siteKey,
          callback: token => onTokenRef.current(token),
          'expired-callback': () => onTokenRef.current(''),
          'error-callback': () => onTokenRef.current(''),
          theme: 'light'
        })
      })
      .catch(() => {})

    return () => {
      cancelled = true

      if (widgetIdRef.current !== null && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current)
        widgetIdRef.current = null
      }
    }
  }, [siteKey, resetSignal])

  return <div ref={containerRef} />
}
